const landingPage = {
  aboutUs: "Σχετικά με εμάς", // translated
  pleaseWait: "Παρακαλώ περιμένετε...", // translated
  featuredHotels: "Επιλεγμένα ξενοδοχεία", // translated
  topPackages: "Κορυφαία πακέτα", // translated
  topTours: "Κορυφαίες εκδρομές", // translated
  ourPartners: "Οι συνεργάτες μας", // translated
  packages: "Πακέτα", // translated
  followUsOnInstagram: "Ακολουθήστε μας στο Instagram", // translated
  whatOurMembersSay: "Τι λένε τα μέλη μας...", // translated
  trustedCarHirePartners: "Αξιόπιστοι συνεργάτες ενοικίασης αυτοκινήτων", // translated
  learnMore: "Μάθε περισσότερα", // translated
};


export default landingPage;
